import React, { useState, useEffect, useRef } from "react";
import styles from "./NewsLetterCard.module.css";
import { FaPlus } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import ReactDOM from "react-dom";

const NewsLetterCard = ({
  name = "",
  isEmpty = false,
  onClick,
  onOptionsClick,
  id,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const optionsRef = useRef();
  const menuRef = useRef();

  const optionsIconRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });


  const toggleOptions = (e) => {
    e.stopPropagation();
    const rect = optionsIconRef.current.getBoundingClientRect();
    setMenuPosition({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    });
    setShowOptions((prev) => !prev);
  };
  
  const handleOptionClick = (option) => {
    onOptionsClick(option, id);
    setShowOptions(false);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        optionsRef.current &&
        !optionsRef.current.contains(event.target) &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  

  return (
    <div
      className={`${styles.card} ${isEmpty ? styles.empty : styles.filled}`}
      onClick={isEmpty ? onClick : undefined}
    >
      {isEmpty ? (
        <div className={styles.emptyContent}>
          <FaPlus size={20} className={styles.plusIcon} />
          <span>Create Newsletter</span>
        </div>
      ) : (
        <div className={styles.filledContent}>
          <div className={styles.title}>{name}</div>
          <div className={styles.optionsWrapper} ref={optionsRef}>
            <div
              className={styles.optionsIcon}
              onClick={toggleOptions}
              ref={optionsIconRef}
            >
              <BsThreeDotsVertical size={18} />
            </div>

            {showOptions &&
              ReactDOM.createPortal(
                <div
                  ref={menuRef}
                  className={styles.optionsMenu}
                  style={{
                    top: `${menuPosition.top}px`,
                    left: `${menuPosition.left}px`,
                    position: "absolute",
                    zIndex: 9999,
                  }}
                >
                  <div onClick={() => handleOptionClick("Edit")}>Edit</div>
                  <div onClick={() => handleOptionClick("Delete")}>Delete</div>
                </div>,
                document.body
              )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsLetterCard;
